module.exports = __webpack_public_path__ + "img/20220328_142314.f1c5ef29.jpg";